// src/components/common/Spinner.tsx
import React from 'react';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: string; // Tailwind color class like 'text-accent-yellow'
  className?: string; // For additional custom classes
  label?: string; // Optional label for accessibility or display
}

const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  color = 'text-accent-light-blue', // Default color
  className = '',
  label = 'Loading...', // Default accessible label
}) => {
  let sizeClasses = '';
  switch (size) {
    case 'sm':
      sizeClasses = 'h-4 w-4 border-2';
      break;
    case 'lg':
      sizeClasses = 'h-10 w-10 border-4';
      break;
    case 'md':
    default:
      sizeClasses = 'h-8 w-8 border-[3px]';
      break;
  }

  return (
    <div
      className={`inline-block ${sizeClasses} ${color} animate-spin rounded-full border-solid border-current border-e-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite] ${className}`}
      role="status"
      aria-label={label}
    >
      <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
        {label}
      </span>
    </div>
  );
};

export default Spinner;